import { render, staticRenderFns } from "./MfaStep.vue?vue&type=template&id=cc08cb76&scoped=true&"
import script from "./MfaStep.vue?vue&type=script&lang=js&"
export * from "./MfaStep.vue?vue&type=script&lang=js&"
import style0 from "./MfaStep.vue?vue&type=style&index=0&id=cc08cb76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc08cb76",
  null
  
)

export default component.exports